import { render } from "./SearchDropdownButtonItem.vue?vue&type=template&id=b1c60f92&scoped=true&ts=true"
import script from "./SearchDropdownButtonItem.vue?vue&type=script&lang=ts"
export * from "./SearchDropdownButtonItem.vue?vue&type=script&lang=ts"

import "./SearchDropdownButtonItem.vue?vue&type=style&index=0&id=b1c60f92&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c60f92"]])

export default __exports__